module.exports = __webpack_public_path__ + "img/4 nacio.3b2a5b7a.jpg";